var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"options":_vm.options},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }